import { useCallback, useMemo } from 'react'
import { ButtonDisabledOrLoader } from '../../../../../../../../../../../baseComponents/Button'
import { OrderData } from '../../../../../../../../../../../specificComponents/inputTableLayouts/order/OrderLayout/types'
import useTwinTranslation from '../../../../../../../../../../../utils/hooks/useTwinTranslation'
import { SellDownloadPdfTemplateButton, SellDownloadButtonPDF, SellPdfPreview, SellViewWorkSheetButton, SellCreateWorkSheetButton, SellDownloadButtonCSV, SellQuickAccessButton, SellDownloadTags } from '../../../../../../../../../../../specificComponents/inputTableLayouts/order/OrderSellLayout/SellButtons'
import { SellDeliveryNoteDuplicateButton, SellDeliveryNoteRecalculateButton } from '../../../SellDeliveryNButtons'
import { getPreparePricesConfigParam, getUserPermissions } from '../../../../../../../../../../../utils/reducers/getters'
import { useNavigate } from 'react-router'
import twinFetchPost, { twinFetchPostJSON } from '../../../../../../../../../../../utils/globals/data'
import { changeErrorMessage } from '../../../../../../../../../../../utils/reducers/reduxDispatch'
import { parseSelectedTableForProcessing } from '../../../../../functions'
import locations from '../../../../../../../../../../../utils/globals/locations'
import { permissionCheck } from '../../../../../../../../../../../baseComponents/PermissionChecker/function'
import { ButtonOrderInfoLeftBase, OrderDivideIntoChaptersButton, OrderProductTypesButton, OrderVariablesButton } from '../../../../../../../../../../../specificComponents/inputTableLayouts/order/OrderLayout/OrderButtons'
import { OrderStepButtonsBase, OrderStepButtonsBaseComponentProps } from '../../../../../../../../../../../specificComponents/inputTableLayouts/order/OrderLayout/OrderButtonsBaseComponent/types'
import { OrderStepButtonsDefaultBaseComponent, OrderStepButtonsNewStyleBaseComponent } from '../../../../../../../../../../../specificComponents/inputTableLayouts/order/OrderLayout/OrderButtonsBaseComponent'
import useIsLoading from '../../../../../../../../../../../utils/hooks/useIsLoading'
import { faFileSlash } from '@fortawesome/pro-light-svg-icons'
import PermissionChecker from '../../../../../../../../../../../baseComponents/PermissionChecker'
import { TwinIconToolTip } from '../../../../../../../../../../../baseComponents/TwinIcon'
import { TwinDictionary } from '../../../../../../../../../../../utils/globals/dictionary'
import { parseOrderTableData } from '../../../../../../../../../../../specificComponents/inputTableLayouts/order/OrderQuoteLayout/function'
import { OrderTableData } from '@teinor/erp/prices/quote/totals'
import { CalculateParamsTy } from '../../../../../../../../../../../baseComponents/Displays/DisplayPrice/types'
import { HeaderDataCalculate } from '@teinor/erp/types/company/order/general'
import useEditDeleteModal, { SetEditDeleteModalTy } from '../../../../../../../../../../../utils/hooks/useEditDeleteModal'
import ModalOrderPaymentMethod from '../../../../../../../../../../../specificComponents/inputTableLayouts/order/OrderLayout/OrderTable/TableComponents/ModalsOrderTable/ModalOrderPaymentMethod'

const SellDeliveryNoteWaitingResponseStepButtons: React.FC<OrderStepButtonsBaseComponentProps> = ({ data, onSubmit, ...rest }) => {
    const { t } = useTwinTranslation()
    return (
        <div className='flex items-center relative gap-5 flex-wrap'>
            <OrderStepButtonsDefaultBaseComponent {...{ data, onSubmit, hookFunction: useSellDeliveryNoteWaitingResponseStepButtonsLogic, ...rest }} className='mr-8' />
            <SellDeliveryNoteProcessInvoiceButton title={t('createInvoice', 'Crear factura')} data={data} />
        </div>
    )
}

const useSellDeliveryNoteWaitingResponseStepButtonsLogic = ({ data, onSubmit, isReadOnly }: OrderStepButtonsBaseComponentProps) => {
    const { t } = useTwinTranslation()
    const name = 'sell_delivery_note_waiting_response_step_buttons'
    const Order = data?.header
    const hideSellQuickAccessButton = !Order?.QuoteOrderId && !Order?.SellOrderId && !Order?.SellDeliveryNoteId && !Order?.SellInvoiceId && !Order?.WorkSheetId && !Order?.relatedSellOrders?.length && !Order?.relatedSellDeliveryNotes?.length && !Order?.relatedSellInvoices?.length && !Order?.relatedWorkSheets?.length

    const defaultButtons = [{ "id": "previewSellDeliveryNote" }, { "id": "downloadSellDeliveryNote" }, { "id": "quickAccess" }, { "id": "duplicateSell" }, { "id": "createWorkSheet" }, { "id": "viewWorkSheet" }, { "id": "sellDeliveryNoteRefund" }]
    
    const sellDeliveryNoteDuplicateText = t('duplicateDeliveryNote', 'Duplicar albarán')
    const sellDeliveryNoteRecalculateText = t('recalculateSellDeliveryNote', 'Recalcular albarán')
    const sellDeliveryNoteDownloadCSVText = t('downloadCsv', 'Descargar csv')
    const sellDeliveryNoteDownloadTagsText = t('printTags', 'Imprimir etiquetas')
    const sellDeliveryNoteViewWorkSheetText = t('goToWorkSheet', 'Ir a la hoja de trabajo')
    const sellDeliveryNoteCreateWorkSheetText = t('createWorkSheet', 'Crear hoja de trabajo')
    const sellDeliveryNoteQuickAccessText = t('quickAccess', 'Acceso rápido')
    const sellDeliveryNotePreviewPDFText = t('previewPdf', 'Previsualizar PDF')
    const sellDeliveryNoteDownloadPdfTemplateText = t('downloadPdfTemplate', 'Descargar plantilla PDF')
    const sellDeliveryNoteDownloadPdfText = t('downloadPdf', 'Descargar PDF')
    const sellDeliveryNoteDivideIntoChaptersText = t('divideIntoChapters', 'Dividir en capítulos')
    const sellDeliveryNoteVariablesText = t('variables', 'Variables')
    const sellDeliveryNoteRefundCreateText = t('createSellDeliveryNoteRefund', 'Crear devolución del albarán')
    const sellDeliveryNoteProductTypesText = t('valueProductTypes', 'Valor tipos de producto')

    const ButtonComponents: OrderStepButtonsBase = useMemo(() => {
            return {
                duplicateSell: {
                    component: SellDeliveryNoteDuplicateButton,
                    extraProps: {
                        title: sellDeliveryNoteDuplicateText,
                        id: 'duplicateSell',
                        allRowData: data,
                    }
                },
                sellDeliveryNoteRefund: {
                    component: SellDeliveryNoteRefundCreateButton,
                    extraProps: {
                        title: sellDeliveryNoteRefundCreateText,
                        id: 'sellDeliveryNoteRefund',
                        Order,
                    }
                },
                recalculateSellDeliveryNote: {
                    component: SellDeliveryNoteRecalculateButton,
                    extraProps: {
                        title: sellDeliveryNoteRecalculateText,
                        id: 'recalculateSellDeliveryNote',
                        allRowData: data,
                        onSubmit
                    }
                },
                downloadSellCsv: {
                    component: SellDownloadButtonCSV,
                    extraProps: {
                        title: sellDeliveryNoteDownloadCSVText,
                        id: 'downloadSellCsv',
                        Order,
                        typeTemplate:'sellDeliveryNote',
                    }
                },
                downloadSellTag: {
                    component: SellDownloadTags,
                    extraProps: {
                        title: sellDeliveryNoteDownloadTagsText,
                        id: 'downloadSellTag',
                        Order,
                        typeTemplate:'sellDeliveryNote',
                    }
                },
                viewWorkSheet: {
                    component: SellViewWorkSheetButton,
                    showButton: Order?.WorkSheetId,
                    extraProps: {
                        title: sellDeliveryNoteViewWorkSheetText,
                        id: 'viewWorkSheet',
                        WorkSheetId: Order?.WorkSheetId
                    }
                },
                createWorkSheet: {
                    component: SellCreateWorkSheetButton,
                    showButton: !Order?.WorkSheetId,
                    extraProps: {
                        title: sellDeliveryNoteCreateWorkSheetText,
                        id: 'createWorkSheet',
                        Order,
                        createURL: '/api/app/order/sell/workSheet/createWorkSheetBySellDeliveryNote',
                        orderField: 'SellDeliveryNoteId',
                        completeData: data 
                    }
                },
                quickAccess: {
                    component: SellQuickAccessButton,
                    showButton: !hideSellQuickAccessButton,
                    extraProps: {
                        title: sellDeliveryNoteQuickAccessText,
                        id: 'quickAccess',
                        Order
                    }
                },
                previewSellDeliveryNote: {
                    component: SellPdfPreview,
                    extraProps: {
                        title: sellDeliveryNotePreviewPDFText,
                        id: 'previewSellDeliveryNote',
                        Order,
                        typeTemplate:'sellDeliveryNote',
                    }
                },
                downLoadSellDeliveryNoteTemplate: {
                    component: SellDownloadPdfTemplateButton,
                    extraProps: {
                        title: sellDeliveryNoteDownloadPdfTemplateText,
                        id: 'downLoadSellDeliveryNoteTemplate',
                        Order,
                        key:'downloadSellDeliveryNotePDFTemplate',
                        typeTemplate:'sellDeliveryNote',
                    }
                },
                downloadSellDeliveryNote: {
                    component: SellDownloadButtonPDF,
                    extraProps: {
                        title: sellDeliveryNoteDownloadPdfText,
                        id: 'downloadSellDeliveryNote',
                        Order,
                        key:'downloadSellDeliveryNote',
                        typeTemplate:'sellDeliveryNote',
                    }
                },
                divideIntoChaptersQuote: {
                    component: OrderDivideIntoChaptersButton,
                    extraProps: {
                        title: sellDeliveryNoteDivideIntoChaptersText,
                        id: 'divideIntoChaptersQuote',
                        allRowData: data,
                        onSubmit,
                        isReadOnly,
                    }
                },
                variablesQuote: {
                    component: OrderVariablesButton,
                    extraProps: {
                        title: sellDeliveryNoteVariablesText,
                        id: 'variablesQuote',
                        allRowData: data,
                        isReadOnly,
                        onSubmit,
                    }
                },
                sellProductTypes: {
                    component: OrderProductTypesButton,
                    extraProps: {
                        title: sellDeliveryNoteProductTypesText,
                        id: 'sellProductTypes',
                        allRowData: data,
                        onSubmit,
                        isReadOnly
                    }
                },
            }
    }, [Order, data, hideSellQuickAccessButton, onSubmit, sellDeliveryNoteDownloadCSVText, sellDeliveryNoteDownloadPdfTemplateText, sellDeliveryNoteDownloadPdfText, sellDeliveryNoteDownloadTagsText, sellDeliveryNoteDuplicateText, sellDeliveryNotePreviewPDFText, sellDeliveryNoteQuickAccessText, sellDeliveryNoteRecalculateText, sellDeliveryNoteViewWorkSheetText, sellDeliveryNoteDivideIntoChaptersText, sellDeliveryNoteVariablesText, isReadOnly, sellDeliveryNoteCreateWorkSheetText, sellDeliveryNoteRefundCreateText, sellDeliveryNoteProductTypesText])

    return { ButtonComponents, name, defaultButtons }
}

export const SellDeliveryNoteWaitingResponseStepButtonsNew: React.FC<OrderStepButtonsBaseComponentProps> = ({ data, onSubmit,setOpenModal,  ...rest }) => {
    const { t } = useTwinTranslation()
    return (
        <div className='flex order_config_buttons_parent items-center relative gap-5 flex-wrap'>
            <OrderStepButtonsNewStyleBaseComponent {...{ data, setOpenModal, onSubmit, hookFunction: useSellDeliveryNoteWaitingResponseStepButtonsLogic, ...rest }} className='mr-8' />
            <SellDeliveryNoteProcessInvoiceButton title={t('createInvoice', 'Crear factura')} data={data} {...{ setOpenModal }}/>
        </div>
    )
}

interface SellDeliveryNoteProcessInvoiceButtonProps {
    title: string
    data: OrderData
}
const SellDeliveryNoteProcessInvoiceButton: React.FC<SellDeliveryNoteProcessInvoiceButtonProps> = ({ data, title }) => {
    const { t } = useTwinTranslation()
    const { openModal, setOpenModal } = useEditDeleteModal()
    const { finalizeOrder, selectedProducts, loading } = useSellDeliveryNoteProcessInvoiceButtonLogic({ data, setOpenModal })
    const invoicePermision = permissionCheck(getUserPermissions('sell.invoice'), 'create')
    const canProcess = selectedProducts.processing.units > 0
    let infoMessage = null
    if (!invoicePermision) {
        infoMessage = t('NotPermissionForCreate', 'No tienes permisos de creación')
    } else if (!canProcess) {
        infoMessage = t('mustAddQuantityToSelectedProducts', 'Debes añadir a los productos seleccionados una cantidad superior a 0')
    }
    return (
        <ButtonOrderInfoLeftBase disabled={infoMessage ? true : false} infoMessage={infoMessage || ''}>
            <div className='min-w-150'>
                <ButtonDisabledOrLoader onClick={() => finalizeOrder('/api/app/order/sell/sellDeliveryNote/createSellInvoiceBySellDeliveryNote', locations.sellInvoiceSingle)} buttonIsDisabled={infoMessage ? true : false} textButton={title} loading={loading} className='w-full' />
            </div>
            {openModal?.type === 'delete' ? <ModalOrderPaymentMethod headerData={data.header} setOpened={() => setOpenModal(null)} allRowData={openModal.allRowData} totalsOrderTableData={openModal.allRowData?.totalsOrderTableData} beforeSubmit={openModal.allRowData.finalizeOrder} /> : null}
        </ButtonOrderInfoLeftBase>
    )
}

interface SellDeliveryNoteProcessInvoiceButtonLogicProps {
    data: OrderData
    setOpenModal: SetEditDeleteModalTy
}

const useSellDeliveryNoteProcessInvoiceButtonLogic = ({ data, setOpenModal }: SellDeliveryNoteProcessInvoiceButtonLogicProps) => {
    const { t } = useTwinTranslation()
    const navigate = useNavigate()
    const noProductsMsg = t('notProcessedAnyProducts', 'No has procesado ningún producto')
    const selectedProducts = useMemo(() => parseSelectedTableForProcessing(data), [data])
    const { startLoading, endLoading, loading } = useIsLoading()

    const finalizeOrder = useCallback(async (url: string, navigateUrl: string, extraProps?: TwinDictionary) => {
        startLoading?.()
        const response = await twinFetchPost(url, { selectedProducts: selectedProducts.forSend.products, OrderId: data?.header?.id, WorkingCenterId: data?.header?.WorkingCenterId, ...extraProps })
        const responseJSON = await response.json()
        if (response.status === 200) {
            navigate(locations.sellInvoiceSingle + '/' + responseJSON.id)
        } else {
            if (responseJSON.errors[0].msg === 'noProducts') {
                changeErrorMessage(noProductsMsg)
            } else if (responseJSON.errors[0].msg === 'Not payment method') {
                const calculateParams = getPreparePricesConfigParam() as CalculateParamsTy
                const headerDataCalculate: HeaderDataCalculate = {
                    OrderCosts: data.header?.OrderCosts,
                    ParamsRoundingDecimals: calculateParams,
                    OrderShipping: data.header?.OrderShipping,
                    isFinished: data.header?.isFinished,
                    OrderAccounts: data.header?.OrderAccounts
                }
                let selectedTableForCalculate = data.tableData
                if (data?.selectedTableData) {
                    selectedTableForCalculate = []
                    for (const element of data?.selectedTableData) {
                        selectedTableForCalculate.push(data.tableData[data.dictPosTableData[element.id]])
                    }
                }
                const totalsOrderTableData = parseOrderTableData(selectedTableForCalculate as OrderTableData, headerDataCalculate)
                setOpenModal({ type: 'delete', allRowData: { extraProps: { OrderId: data?.header?.id, WorkingCenterId: data?.header?.WorkingCenterId, selectedProducts: selectedProducts.forSend.products }, createUrl: url, navigateUrl, total: totalsOrderTableData.totals.total, finalizeOrder } })
            } else {
                changeErrorMessage(responseJSON.errors[0].msg)
            }
        }
        endLoading?.()
    }, [data, noProductsMsg, navigate, selectedProducts, startLoading, endLoading, setOpenModal])


    return { finalizeOrder, selectedProducts, loading }
}

interface SellDeliveryNoteRefundCreateButtonProps extends SellDeliveryNoteRefundCreateButtonLogicProps {
    id: string
    title: string
    className?: string
    children?: React.ReactNode
}

export const SellDeliveryNoteRefundCreateButton: React.FC<SellDeliveryNoteRefundCreateButtonProps> = ({ id, className, title, Order, children }) => {
    const { creteSellDeliveryNoteRefund } = useSellDeliveryNoteRefundCreateButtonLogic({ Order })
    return (
        <PermissionChecker userPermissions={getUserPermissions('sell.refundDeliveryNote')} permission={'create'}>
            <div className={'flex flex-col relative ' + (className || '')} onClick={creteSellDeliveryNoteRefund}>
                {children ?? <TwinIconToolTip id={'sellDeliveryNoteRefund' + id} classNameIcon={'regular22 hover:text-green-43 ' + (className || '')} message={title} icon={faFileSlash} />}
            </div>
        </PermissionChecker>
    )
}

interface SellDeliveryNoteRefundCreateButtonLogicProps {
    Order: TwinDictionary
}

const useSellDeliveryNoteRefundCreateButtonLogic = ({ Order }: SellDeliveryNoteRefundCreateButtonLogicProps) => {
    const navigate = useNavigate()
    const creteSellDeliveryNoteRefund = useCallback(async () => {
        const result = await twinFetchPostJSON('/api/app/order/sell/sellDeliveryNote/getSellDeliveryNoteComplete', { id: Order?.id, includeRelations: true })
        if (result) {
            const myId = result?.header?.id
            if (myId) {
                navigate(locations.sellDeliveryNoteRefundMulti + '/generateFromDeliveryNote/' + myId)
            }
        }
    }, [Order?.id, navigate])
    return { creteSellDeliveryNoteRefund }
}


export default SellDeliveryNoteWaitingResponseStepButtons